import React, { useEffect, useState } from "react";
import { About } from "../components/about";
import JsonData from "../data/data.json";
import Footer from "../components/footer";
import SlidingBanner from "../components/Banner";

const AboutPage = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);
  const banners = [
    {
      id: 1,
      img: "../img/slideBanner/SLIDE1.jpg",
      alt: "Slide 1",
    },
    {
      id: 2,
      img: "../img/slideBanner/SLIDE2.jpg",
      alt: "Slide 2",
    },
    {
      id: 3,
      img: "../img/slideBanner/SLIDE3.jpg",
      alt: "Slide 3",
    },
  ];
  return (
    <div>
       <SlidingBanner banners={banners} />
        
       <About data={landingPageData.About} />
    </div>
  );
};

export default AboutPage;
